import { ultimosModificadosQueryGqlExpanded } from '../data/ultimo-modificados-query'
import { UltimosModificadosQueryGqlExtendedQuery } from '../../../core/types/graphql'
import { useQuery } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'

export const useLastCreatedBox = () => {
  const { data: { ultimosModificados } = {}, isLoading: loading } = useQuery({
    queryKey: ['ultimosModificadosExpanded'],
    queryFn: async () =>
      await request<UltimosModificadosQueryGqlExtendedQuery>(
        ultimosModificadosQueryGqlExpanded
      )
  })

  return { ultimosModificados, loading }
}
